import { ref } from 'vue';
import { createGlobalState } from '@vueuse/core';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { PermissionService } from '@/domains/permission/services/permission-service';
import { useDisposes } from '@/composables/use-disposes';

export const usePermission = createGlobalState(() => {
    const permissionService = injectService<PermissionService>(PermissionService);

    const { disposes } = useDisposes();

    const permissions = ref(permissionService.getModelData());
    disposes.push(permissionService.onStatesChange(state => permissions.value = state));

    return {
        permissions,
    };
});
